export const DefaultImage = {
  Background: '',
  MobileBackground: 'https://webpay-1252325870.cos.accelerate.myqcloud.com/qw-2/d50bde16-6272-42b7-a91c-4cfa46f2e596.png',
  Carousel: 'https://webpay-1252325870.cos.accelerate.myqcloud.com/lorem/d268844c-5fee-4642-ad42-7f98e608c306.png',
  Header: 'https://webpay-1252325870.cos.accelerate.myqcloud.com/lorem/ec237550-ea87-4ad8-9288-dade8119cd51.png',
  Footer: 'https://webpay-1252325870.cos.accelerate.myqcloud.com/lorem/b6a7d362-b2df-4cfc-86f1-84bdfbbba813.png',
  Collapse: 'https://webpay-1252325870.cos.accelerate.myqcloud.com/lorem/e2bc8e86-f5a7-4c71-99bf-387c3634aa21.png',
  // ImageText: 'https://webpay-1252325870.cos.accelerate.myqcloud.com/lorem/54728123-854c-497b-8b7e-f454475b01a4.png',
  store: 'https://kopglobal.com/site-builder/prod/1713777236079_20240403-180959.png',
  Diamond3: 'https://kopglobal.com/site-builder/prod/1743036511165_20250327-084628.png',
  ImageText: 'https://kopglobal.com/site-builder/prod/1009280/1003590/1087632/1723788706630_%E6%A8%A1%E6%9D%BF2.png',
  Corner: 'https://kopglobal.com/site-builder/test/1734055702958_20241213-100806.png',
  recharge: {
    pic1: 'https://kopglobal.com/site-builder/prod/1747017879322_20250512-104426.png',
    pic2: 'https://kopglobal.com/site-builder/prod/1747017772070_20250512-104239.png',
    pic3: 'https://kopglobal.com/site-builder/prod/1747017912955_20250512-104500.png',
    pic4: 'https://kopglobal.com/site-builder/prod/1747017959456_20250512-104549.png',
    handleIcon: 'https://kopglobal.com/site-builder/prod/1754879329281_handle-icon.png'
  },
  storeV2: 'https://kopglobal.com/site-builder/test/1736474405106_20250110-095939.png',
  storeV3: 'https://kopglobal.com/site-builder/prod/1756889961364_20250903-163559.png',
  storeV3Active: 'https://kopglobal.com/site-builder/prod/1756890945404_20250903-171415.png',
  CustomerLogo: 'https://kopglobal.com/site-builder/prod/1749527396526_20250610-114942.png',
  missionCenterIcon: 'https://kopglobal.com/site-builder/prod/1752559309068_20250715-135954.gif',
  seoIcon: 'https://kopglobal.com/site-builder/prod/1752559506260_20250710-092524.png',
  helpIcon: 'https://kopglobal.com/site-builder/prod/1754016290559_help-icon.png',
  dialogBlockImage: 'https://kopglobal.com/site-builder/prod/1753688490243_20250728-153758.png',
  quenUnlock: {
    arrow: 'https://kopglobal.com/site-builder/prod/1761030714399_20251021-143751.png',
    lock: 'https://kopglobal.com/site-builder/prod/1761102538432_20251022-110840.png'
  },
  sign: {
    done: 'https://kopglobal.com/site-builder/prod/1764312293039_20251128-144441.png'
  },
  VipLevelUpPrizeBg: 'https://kopglobal.com/site-builder/prod/1768354418167_20260114-093311.png',
  VipRightsPropBg: 'https://kopglobal.com/site-builder/prod/1768875079665_20260120-101106.png',
  VipRightsPropIcon1: 'https://kopglobal.com/site-builder/prod/1768875587352_20260120-101509.png',
  VipRightsPropIcon2: 'https://kopglobal.com/site-builder/prod/1768875380015_20260120-101512.png',
  VipRightsPropIcon3: 'https://kopglobal.com/site-builder/prod/1768875438525_20260120-101515.png'
}
